// extracted by mini-css-extract-plugin
module.exports = {"h1":"item_h1__giupU","h2":"item_h2__NOmfo","h3":"item_h3__00NQW","h4":"item_h4__4PvZe","thInTbodyTable":"item_thInTbodyTable__4LNzD"};